import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';
import PositionList from "./PositionList";
import PositionsLineGraph from './PositionsLineGraph';
import { getPositionStats } from "../utils/tradeStats";
import { PERFORMANCE_STAT_ROWS } from "../utils/performanceStatsRows";

class ToggleStatsPositions extends Component {
render() {
    const positions = this.props.positions || [];
    const accountInfo = this.props.accountInfo || {balance:0};
    const cashflows = this.props.cashflows || [];
    const rawStartingAmount = Number(this.props.startingAmount);
    const balanceStart = Number.isFinite(rawStartingAmount) ? parseFloat(rawStartingAmount.toFixed(2)) : 0;
    const positionStats = getPositionStats(positions, accountInfo, balanceStart, cashflows);
    const activeTab = this.props.activeTab || "equity";
    const isTradesTab = activeTab === "trades";
    const isEquityTab = activeTab === "equity";
    const visibleStats = this.props.visibleStats || {};
    const statsFiltersOpen = Boolean(this.props.statsFiltersOpen);
    const statsVisibilitySaving = Boolean(this.props.statsVisibilitySaving);
    const statsRows = PERFORMANCE_STAT_ROWS
      .filter((item) => visibleStats[item.key] !== false)
      .map((item) => ({
        key: item.key,
        label: item.label,
        value: item.getValue(positionStats),
      }));

    return (
      <Row className="d-flex flex-wrap justify-content-center mb-4">
        {isTradesTab ? (
              <PositionList
                positions={positions}
                resetState={this.props.resetState}
                title="Closed Trades"
              />
        ) : isEquityTab ? (
          <div className="past-performance-panel app-widget-panel">
            <div className="past-performance-panel__header">
              <h3 className="past-performance-panel__title app-widget-title">Equity Curve</h3>
            </div>
            <Row className="g-2 g-md-3 mb-4 app-widget-grid equity-summary-grid">
              <Col xs={4} md={4} className="app-widget-grid__col">
                <div className="app-metric-card equity-summary-card">
                  <span className="app-metric-label">Start</span>
                  <span className="app-metric-value">£{balanceStart}</span>
                </div>
              </Col>
              <Col xs={4} md={4} className="app-widget-grid__col">
                <div className="app-metric-card equity-summary-card">
                  <span className="app-metric-label">Net Profit</span>
                  <span className="app-metric-value">£{positionStats.total_profit}</span>
                </div>
              </Col>
              <Col xs={4} md={4} className="app-widget-grid__col">
                <div className="app-metric-card equity-summary-card">
                  <span className="app-metric-label">Gained</span>
                  <span className="app-metric-value">{positionStats.percentage_gain}%</span>
                </div>
              </Col>
            </Row>
            <div className="past-performance-chart-shell">
              <div className="line-chart-container">
                <PositionsLineGraph
                  data={positionStats}
                  positions={positions}
                  cashflows={cashflows}
                  resetState={this.props.resetState}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="past-performance-panel app-widget-panel">
            <div className="past-performance-panel__header past-performance-panel__header--with-actions">
              <h3 className="past-performance-panel__title app-widget-title">Performance Stats</h3>
              <Button
                className="stats-filter-toggle"
                type="button"
                aria-label="Stats filters"
                aria-expanded={statsFiltersOpen}
                active={statsFiltersOpen}
                onClick={this.props.onToggleStatsFilters}
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path
                    d="M4 5h16l-6 7v5l-4 2v-7L4 5z"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  />
                </svg>
              </Button>
            </div>
            {statsFiltersOpen && (
              <div className="stats-filter-popover" role="dialog" aria-label="Stats display filters">
                <div className="stats-filter-popover__header">
                  <h4 className="stats-filter-popover__title">Stats Display</h4>
                  {statsVisibilitySaving && (
                    <span className="stats-filter-popover__status">Saving...</span>
                  )}
                </div>
                <div className="stats-filter-grid">
                  {PERFORMANCE_STAT_ROWS.map((stat) => (
                    <label key={stat.key} className="stats-filter-option">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={visibleStats[stat.key] !== false}
                        onChange={(event) => this.props.onStatVisibilityChange?.(stat.key, event.target.checked)}
                      />
                      <span>{stat.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            <Row className="d-flex flex-wrap justify-content-center mb-0">
              <Col xs={12}>
                <div className="table-responsive past-performance-stats-shell">
                  <table className="table table-sm table-algo_color table-hover mb-0">
                    <thead>
                      <tr>
                        <th scope="col">Metric</th>
                        <th scope="col" className="text-end">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statsRows.length > 0 ? statsRows.map((item) => (
                        <tr key={item.key}>
                          <td>{item.label}</td>
                          <td className="text-end">{item.value}</td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="2" className="text-center">No stats selected</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Row>
    );
  }
}

export default ToggleStatsPositions;
